import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import MainContent from "./MainContent";

const Layout = ({ username, role, onLogout }) => {
  const [activeTab, setActiveTab] = useState(() => {
    return role === "staff" ? "orders" : (sessionStorage.getItem("admin_activeTab") || "orders");
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    if (role === "staff" && activeTab !== "orders") {
      setActiveTab("orders");
    }
    sessionStorage.setItem("admin_activeTab", activeTab);
  }, [activeTab, role]);

  const handleTabClick = (tab) => {
    if (role === "staff" && tab !== "orders") return;
    setActiveTab(tab);
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <div className="flex min-h-screen">
        <Sidebar
          username={username}
          role={role}
          activeTab={activeTab}
          handleTabClick={handleTabClick}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
          onLogout={onLogout}
        />

        <MainContent
          activeTab={activeTab}
          role={role}
          setIsSidebarOpen={setIsSidebarOpen}
        />
      </div>
    </div>
  );
};

export default Layout;
